import { initializeApp } from 'firebase/app'
import {
  connectAuthEmulator,
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence,
  browserPopupRedirectResolver,
} from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

// Explicit persistence fallback chain. getAuth()'s default persistence resolves to IndexedDB,
// which iOS Safari can block or HANG (Private Browsing, "Block All Cookies", in-app webviews, or
// an ITP storage purge) — leaving onAuthStateChanged stuck and the whole app on an infinite
// loader, or silently signing the user out. An ordered list lets the SDK fall through
// IndexedDB -> localStorage -> sessionStorage -> in-memory and still resolve auth (even if only
// for the session) instead of deadlocking. We pass popupRedirectResolver explicitly because we
// no longer go through getAuth's default resolver, so signInWithPopup/Redirect keeps working.
let auth
try {
  auth = initializeAuth(app, {
    persistence: [
      indexedDBLocalPersistence,
      browserLocalPersistence,
      browserSessionPersistence,
      inMemoryPersistence,
    ],
    popupRedirectResolver: browserPopupRedirectResolver,
  })
} catch {
  // initializeAuth throws if auth was already initialized for this app (e.g. dev HMR or a double
  // import). Fall back to the already-configured instance.
  auth = getAuth(app)
}

// Local work beside v2 (ai_app_backend's `make local`): sign-ins go to the Firebase Auth emulator on this computer,
// which holds only made-up people. Never in a production build, so a stray setting can't break real sign-ins.
const authEmulator = process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_HOST
if (authEmulator && process.env.NODE_ENV !== 'production') {
  try {
    connectAuthEmulator(auth, `http://${authEmulator}`, { disableWarnings: true })
  } catch {
    // Already connected: dev HMR loaded this module again with the same instance.
  }
}
export { auth }
